import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  GetTokenReservationPayload,
  GetTokenReservationResponse,
} from '@features/token-management/api/token-management.types';
import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

export const tokenManagementApiSlice = createApi({
  reducerPath: 'tokenManagementApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => {
    return {
      createTokenReservation: builder.mutation<GetTokenReservationResponse, GetTokenReservationPayload>({
        query: (payload) => ({
          url: `/api/estimation/v1/reservations`,
          method: 'POST',
          body: payload,
        }),
      }),
      updateTokenReservation: builder.mutation<
        GetTokenReservationResponse,
        { reservationId: string; payload: GetTokenReservationPayload }
      >({
        query: ({ reservationId, payload }) => ({
          url: `/api/estimation/v1/reservations/${reservationId}`,
          method: 'PUT',
          body: payload,
        }),
      }),
      cancelTokenReservation: builder.mutation({
        query: (reservationId: string) => ({
          url: `/api/reservation/v1/${reservationId}/cancel`,
          method: 'PUT',
        }),
      }),
      getEligibleTokens: builder.query<{ totalEligibleTokens: number }, void>({
        query: () => ({ url: '/api/stats/v1/tokens/eligible' }),
      }),
    };
  },
});

export const {
  useCreateTokenReservationMutation,
  useUpdateTokenReservationMutation,
  useCancelTokenReservationMutation,
  useGetEligibleTokensQuery,
} = tokenManagementApiSlice;
